/**
 * Created by joellee on 6/1/16.
 */
commonModule.directive('tlcPrefixedInput', ['$browser', function($browser) {
    return {
        require: 'ngModel',
        link: function($scope, $element, $attrs, ctrl) {
            var keyArgs = ($attrs["tlcPrefixedInput"] || "").split(",");
            var prefix = keyArgs[0] || "",
                legal = keyArgs[1] || "0-9A-Z",
                minLen = +keyArgs[2] || 0,  // including any prefix
                maxLen = +keyArgs[3] || 0;  // including any prefix; 0 or missing means no upper bound

            var separator = "-";
            var formattedPrefix = prefix + (prefix && separator); // empty if prefix is empty
            var minSuffixLen = minLen < prefix.length ? 0 : minLen - prefix.length;
            var maxSuffixLen = maxLen == 0
                ? 10000
                : maxLen < minLen || maxLen < prefix.length ? minSuffixLen : maxLen - prefix.length;

            var regNotLegalChar = new RegExp("[^" + legal + "]", "g"),
                regLegalSuffix = new RegExp("^[" + legal + "]*$");

            function extractSuffix(value) {
                value = value || "";
                var val = value.indexOf(prefix) == 0
                    ? value.slice(prefix.length)
                    : "";
                return val.replace(regNotLegalChar, "").slice(0, maxSuffixLen);  //this will remove separator if present
            }

            function listener() {
                var viewValue = $element.val();
                viewValue =  formattedPrefix + extractSuffix(viewValue);
                $element.val(viewValue);
            };

            ctrl.$parsers.unshift(function parse(viewValue) {
                var modelValue =  prefix + extractSuffix(viewValue);
                return modelValue;
            });

            ctrl.$formatters.unshift(function format(modelValue) {
                var viewValue =  formattedPrefix + extractSuffix(modelValue);
                return viewValue;
            });


            ctrl.$render = function() {
                var viewValue = formattedPrefix + extractSuffix(ctrl.$viewValue);
                $element.val(viewValue);
            }

            $element.bind('change', listener);

            $element.bind('keyup', function(event) {
                var key = event.keyCode;
                if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
                    return;
                }
                $browser.defer(listener);
            });

            $element.bind('paste cut', function() {
                $browser.defer(listener);
            });

            ctrl.$validators.tlcPrefixedInput = function(modelValue, viewValue) {
                modelValue = modelValue || "";
                if (ctrl.$isEmpty(modelValue || viewValue))
                    return true;

                var suffix  = extractSuffix(modelValue);
                return modelValue.indexOf(prefix) == 0 && regLegalSuffix.test(suffix) &&
                       suffix.length >= minSuffixLen && suffix.length <= maxSuffixLen;
            };
        }
    };
}]);